import { BrandImg } from "@/components/site/Brand";

export const PortalShell = ({ children, testId }) => (
  <div className="min-h-screen bg-rc-bg text-rc-ink" data-testid={testId}>
    <header className="border-b border-rc-line">
      <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-5">
        <BrandImg alt="The Rhett Co" className="h-7" />
        <span className="font-mono-rc text-[11px] uppercase tracking-[0.22em] text-rc-muted">Client portal</span>
      </div>
    </header>
    <main className="mx-auto max-w-3xl px-5 py-10 sm:py-14">{children}</main>
    <footer className="mx-auto max-w-3xl px-5 pb-10 text-xs text-rc-muted">The Rhett Co LLC · Charlotte, NC · admin@rhettco.org · 839-213-2108</footer>
  </div>
);

export const PortalMessage = ({ title, text }) => (
  <div className="rounded-[24px] border border-rc-line bg-rc-surface p-8 text-center" data-testid="portal-message">
    <p className="font-display text-3xl">{title}</p>
    <p className="mt-3 text-rc-body">{text}</p>
  </div>
);

export const ContractBody = ({ body }) => (
  <div className="space-y-3 text-[15px] leading-relaxed text-rc-body" data-testid="contract-body">
    {body.split("\n").map((line, i) =>
      line.startsWith("## ") ? (
        <h3 key={i} className="pt-4 font-display text-2xl text-rc-ink">{line.slice(3)}</h3>
      ) : line.trim() ? (
        <p key={i}>{line}</p>
      ) : null
    )}
  </div>
);
